
define('modules/application/wizard/classes/technicalBusAlarm',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {

    var eventsToBind = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
      
      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "technicalBusAlarm",
        template: "application/wizard/sections/genericCollectionSection/technicalBusAlarm",
        events: _.extend(eventsToBind, {
          "change .interface": "interfaceChangedEventHandler",
          "change .type": "typeChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler"
        }),
        initialize: function() {
          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("change:number", this.render);
          this.model.bind("change:number", this.render, this);
        },
        typeChangedEventHandler: function(e) {
          var type = e.currentTarget.value;

          //Update the model
          this.model.setType(e.target.value);
        },
        interfaceChangedEventHandler: function(e) {
          var interfacePackageClassId = e.target.value;
          this.model.setInterface(e.target.value);
          this.render();
        },
        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        }
      }),
      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          selected: false,
          description: ""
        },

        initialize: function() {
          genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);
          this.fetchPackages();
          this.bind("change:type", this.typeChangedEventHandler, this);
          this.bind("change:_interface", this.interfaceChangedEventHandler, this);

          if (!this.get("_interface"))
            this.setInterface(this.get("fetchedInterfaces")[0].packageClassId);
          else
            this.interfaceChangedEventHandler();

          if (!this.get("type"))
            this.setType(this.retrieveFilteredTypes()[0].packageClassId);
          else
            this.typeChangedEventHandler(true);
        },

        retrieveFilteredTypes: function() {
          var interfacePackageClassId = this.get("_interface").packageClassId,
            filteredTypes = [],
            compatibleTypes = [],
            that = this;

          if (interfacePackageClassId) {
            compatibleTypes = _.filter(this.get("fetchedTypes"), function(iterableType) {
              return iterableType.specialVars.technicalBusCouplingValue === that.get("_interface").specialVars.technicalBusCouplingValue;
            });
          }

          return compatibleTypes;
        },

        setInterface: function(interfacePackageClassId) {
          var filteredInterfaces = [];
          var originalInterfaces = this.get("fetchedInterfaces"),
            originalInterfacesLength = originalInterfaces.length;
          var i = 0;

          //Cloning interface's array
          for (i = 0; i < originalInterfacesLength; i++) {
            filteredInterfaces.push(_.extend(originalInterfaces[i]));
          }

          //retrieve the correct interface
          filteredInterfaces = _.filter(filteredInterfaces, function(currentInterface) {
            return (currentInterface.packageClassId === interfacePackageClassId);
          });

          //Setting interface attribute
          if (filteredInterfaces.length > 0)
            this.set("_interface", filteredInterfaces[0]);
        },

        setType: function(typePackageClassId) {
          var filteredTypes = [];
          var originalTypes = this.get("fetchedTypes"),
            originalTypesLength = originalTypes.length;
          var i = 0;

          //Cloning interface's array
          for (i = 0; i < originalTypesLength; i++) {
            filteredTypes.push(_.extend(originalTypes[i]));
          }

          //retrieve the correct interfacePackageClassId
          filteredTypes = _.filter(filteredTypes, function(currentInterface) {
            return (currentInterface.packageClassId === typePackageClassId);
          });

          //Setting interface attribute
          if (filteredTypes.length > 0)
            this.set("type", filteredTypes[0]);
        },

        typeChangedEventHandler: function(maintainValue) {
          var type = this.get("type"),
            that = this;

          //Merging with wizard package attributes
          var packageClassAttributes = _.filter(that.get("fetchedTypes"), function(pack) {
            return pack.packageClassId === type;
          });

          if (packageClassAttributes.length === 1)
            packageClassAttributes = packageClassAttributes[0];
          _.extend(this.attributes.type, packageClassAttributes);

          //Merging with item's attributes
          if ((type) && (type.packageClassId)) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(type.packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              products = products[0];
              _.extend(that.attributes.type, products);

              that.attributes.type.secondaryProducts = secondaryProducts;
            });
          } else {
            this.resetValues();
          }

          that.trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        interfaceChangedEventHandler: function() {
          var _interface = this.get("_interface"),
            that = this;

          //Merging with wizard package attributes
          var packageClassAttributes = _.filter(that.get("fetchedInterfaces"), function(pack) {
            return pack.packageClassId === _interface.packageClassId;
          });

          if (packageClassAttributes.length === 1)
            packageClassAttributes = packageClassAttributes[0];
          _.extend(this.attributes, packageClassAttributes);

          //Merging with item's attributes
          if ((_interface) && (_interface.packageClassId)) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(_interface.packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              products = products[0];
              _.extend(that.attributes._interface, products);

              var _interface = that.get("_interface");

              _interface.secondaryProducts = secondaryProducts;
              that.set("_interface", _interface);
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            });
          } else {
            this.resetValues();
          }
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        fetchPackages: function() {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this,
              i = 0;

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(412, function(data) {
              for (i = 0; i < data.packages.length; i++) {
                data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
              }
              that.set("fetchedInterfaces", data.packages);
            });

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(413, function(data) {
              for (i = 0; i < data.packages.length; i++) {
                data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
              }
              that.set("fetchedTypes", data.packages);
            });
          }
        },

        deliverCurrent: function() {
          if (this.get("_interface").specialVars) {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
            var interfaceCurrentConsumption = this.get("_interface").specialVars ? this.get("_interface").specialVars.currentConsumption : 0;
            var alarmCurrentConsumption = this.get("type").specialVars ? this.get("type").specialVars.currentConsumption : 0;

            if (interfaceCurrentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(interfaceCurrentConsumption);
            else if (interfaceCurrentConsumption > 0)
              consumptionIndicatorModel.addCurrentConsumption(interfaceCurrentConsumption);

            if (alarmCurrentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(alarmCurrentConsumption);
            else if (alarmCurrentConsumption > 0)
              consumptionIndicatorModel.addCurrentConsumption(alarmCurrentConsumption);
          }
        }
      })

    });

    var technicalBusAlarm = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend(),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),

          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          duplicateItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.duplicateSelectedItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          removeItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToRemove = this.model.removeSelectedItem();
            if (elementToRemove) {
              var viewToRemove = this.getView(function(view) {
                return (elementToRemove === view.model);
              });
              if (viewToRemove) {
                this.model.sortItems();
                viewToRemove.$el.remove();
                this.afterRender();
              }
            }
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection.models.length;
            var collectionItemView = genericCollectionItem.View;
            var i = 0;

            for (i = 0; i < collectionLength; i++)
              this.insertView(".elements", new collectionItemView({
                model: collection.models[i]
              }));
          },

          afterRender: function() {
            if (this.model.get("collection").length === 0)
              this.$el.append("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9018") + "</h4>");
            window.customizeFormElements.call();
          }
        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAI8_11",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000020"
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });
          var collection;
          var oldCollection, i = 0;

          if (this.get("collection").length) {
            oldCollection = this.get("collection");

            if (oldCollection.models)
              oldCollection = oldCollection.models;
          }

          this.set("collection", new collectionModel());
          collection = this.get("collection");

          if (oldCollection) {
            for (i = 0; i < oldCollection.length; i++) {
              if (!oldCollection[i].attributes)
                this.addItem(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator")
                }, oldCollection[i]));
              else
                collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
            }
          }

          if (collection.length < this.get("minItem"))
            this.addItem();

          this.sortItems();

          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.checkForTrafoPackages);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.checkForTrafoPackages, this);
        },

        isPossibleToAdd: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var technicalRadioAlarmLength = BticinoS4B.Instances.Models.ApplicationModel.get("technicalRadioAlarmLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("technicalRadioAlarmLength") : 0;
          return (collectionLength + technicalRadioAlarmLength + 1) <= this.get("maxItem");
        },

        addItem: function(itemModel) {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          if (this.isPossibleToAdd()) {
            var collectionItemModel = genericCollectionItem.Model;

            if (itemModel)
              defaultItem = new collectionItemModel(itemModel);
            else
              defaultItem = new collectionItemModel({
                number: this.getNewNumber(),
                collectionEventAggregator: this.get("collectionEventAggregator")
              });

            collection.add(defaultItem);
            this.set("collection",collection);
            this.sortItems();
            this.trigger("updateViews", this.get("collection").length);
            window.BticinoS4B.eventAggregator.trigger("technicalBusAlarm:changed", collection.models.length);
            BticinoS4B.Instances.Models.ApplicationModel.set("technicalBusAlarmLength", collection.models.length);
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            return defaultItem;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model;
          var itemNumber = this.getNewNumber();

          var collection = this.get("collection"),
            collectionLength = collection.length;
          var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
          var radioSensorsLength = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;

          if (this.isPossibleToAdd()) {
            if (modelToDuplicate) {
              modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);
              if (modelToDuplicate) {
                if (modelToDuplicate.get("partOfKit") !== undefined) {
                  modelToDuplicate.set("partOfKit", undefined);
                }

                modelToDuplicate.set("number", itemNumber);
                this.get("collection").add(modelToDuplicate);

                BticinoS4B.Instances.Models.ApplicationModel.set("technicalBusAlarmLength", collection.models.length);
                window.BticinoS4B.eventAggregator.trigger("technicalBusAlarm:changed", collection.models.length);
                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

                //Trigger event for zone validation
                this.sortItems();
                this.trigger("item:added");
                this.trigger("render:requested");

                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
                return modelToDuplicate;
              } else
                return false;
            } else
              return false;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++) {
            collection.models[i].set("number", (i + 1));
            if (i === (collectionLength - 1))
              collection.models[i].set("selected", true);
            else
              collection.models[i].set("selected", false);
          }
        },

        removeItem: function(modelToRemove, _silent) {
          var silent = false;

          if (_silent)
            silent = _silent;

          if (!modelToRemove.get("partOfKit") || silent) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.trigger("updateViews", this.get("collection").length);

              this.sortItems();

              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");
              window.BticinoS4B.eventAggregator.trigger("technicalBusAlarm:changed", this.get("collection").models.length);
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              return modelToRemove;
            }
          } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
        },

        selectedItemChangedEventHandler: function(choosenElement) {
          var collection = this.get("collection");
          for (var i = 0; i < collection.models.length; i++) {
            if (collection.models[i] !== choosenElement)
              collection.models[i].set("selected", false);
          }
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.technicalBusAlarm = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.technicalBusAlarm = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.technicalBusAlarm = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.technicalBusAlarm = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.technicalBusAlarm = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.technicalBusAlarm = this;
              break;
          }
          BticinoS4B.Instances.Models.ApplicationModel.set("technicalBusAlarm", this);
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++)
            collection.models[i].deliverCurrent();
        },

        checkForTrafoPackages: function() {
          var collection = this.get("collection"),
            trafoFound = _.filter(collection.models, function(iterableType) {
              return iterableType.get("type").specialVars.isTrafo === true;
            }).length > 0;
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.trafoFound = trafoFound;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.trafoFound = trafoFound;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.trafoFound = trafoFound;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.trafoFound = trafoFound;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("trafoFound", trafoFound);
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return technicalBusAlarm;

  });